module.exports = __webpack_public_path__ + "static/media/invite-delete-icon.ef006b69.svg";